import { DraftVisitStatusEnum, PersonTypeEnum } from 'Application/Visits/Actions/enums'
import { plateTypeFormat } from 'Application/Visits/Actions/plateType'
import {
  clearNewVisit,
  setCarInfo,
  setCustomerInfo,
  setDraftVisitId,
} from 'Application/Visits/Actions/reducer'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import Icon from 'Components/Icon'
import { useSettings } from 'Contexts/SettingsContext'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'Store/selectors'
import Consts from 'Utils/Consts'
import gregorianDate from 'Utils/gregorianDate'

const StartVisitButton: React.FC<{ draftVisit: any }> = ({ draftVisit }) => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const customerInfo = useAppSelector(s => s.visits.newVisit.customerInfo)
  const { settings } = useSettings()

  const storeFileType = settings?.REACT_APP_STORE_FILE_TYPE ?? Consts.env.REACT_APP_STORE_FILE_TYPE

  const canStartDraft = [
    DraftVisitStatusEnum.AutoAssigned,
    DraftVisitStatusEnum.ManualAssigned,
    DraftVisitStatusEnum.ReferredByAdmin,
    DraftVisitStatusEnum.ReferredByExpert,
  ].includes(draftVisit.assignedDraftVisitStatus || 1)

  const startDraftVisitHandler = () => {
    dispatch(clearNewVisit(storeFileType))

    dispatch(setDraftVisitId(draftVisit.draftVisitId))

    dispatch(
      setCarInfo({
        plate: {
          plateType: draftVisit.plateType ? draftVisit.plateType : 1,
          plateTypeTitle: draftVisit.plateTypeTitle,
          carOtherNumber: draftVisit.plateCarOtherNumber,
          carSerial: draftVisit.plateCarSerial,
          char: draftVisit.plateChar,
          cityCode: draftVisit.plateCityCode,
          motorCycleOtherNumber: draftVisit.plateAdditionalNumber,
          motorCycleSerial: draftVisit.plateMotorCycleSerial,
          type: plateTypeFormat(draftVisit.plateType),
        },
        vehicleTypeId: draftVisit.vehicleTypeId,
        hasTrailer: null,
        vehicleBrandId: draftVisit.vehicleBrandId,
        vehicleTipId: draftVisit.vehicleTipId,
        vehicleColorId: draftVisit.vehicleColorId,
        vehicleUsageId: draftVisit.vehicleUsageId,
        vehicleStatus: null,
        numberOfCylinders: null,
        yearOfConstruction: draftVisit.yearOfConstruction,
        vehicleMileage: null,
        chassisNumber: draftVisit.chassisNumber,
        engineNumber: draftVisit.engineNumber,
        VIN: draftVisit.vin,
        cargoCompartmentId: null,
      }),
    )

    dispatch(
      setCustomerInfo({
        personType: draftVisit.personType !== null ? draftVisit.personType : null,
        isDeath: draftVisit.personType === PersonTypeEnum.REAL ? customerInfo.isDeath : false,
        firstName: draftVisit.firstName,
        lastName: draftVisit.personType === PersonTypeEnum.REAL ? draftVisit.lastName : '',
        identityCode: draftVisit.identityCode,
        birthDate:
          draftVisit.personType === PersonTypeEnum.REAL
            ? gregorianDate(new Date(draftVisit.birthDate))
            : null,
        gender: draftVisit.gender,
        mobilePhoneNumber: draftVisit.contactPhone,
        visitLocationType: null,
        stateId: null,
        cityId: null,
        location: {
          address: draftVisit.address,
        },
        branchCode: null,
      }),
    )

    navigate(VisitsPaths.NewVisit)
  }

  return (
    <button
      onClick={() => startDraftVisitHandler()}
      disabled={!canStartDraft}
      className="btn btn-outline-primary btn-lg flex gap-1 items-center justify-center"
    >
      {t('START_DRAFT_VISIT')}
      <Icon className="cursor-pointer" name="KeyboardArrowLeft" />
    </button>
  )
}

export default StartVisitButton
